var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWastepumpout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a,.c{fill-rule:evenodd;}.b,.c{fill:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.2 3.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10,10.3c0-1,1-1,2-1h1.5c1.93,0,3.5-1.07,3.5-3s-1.57-3-3.5-3H2a1,1,0,0,0,0,2H13.5c.83,0,1.5.17,1.5,1s-.67,1-1.5,1H12c-2.5,0-4,.5-4,3s1.5,3,4,3h4a1.075,1.075,0,0,0,1-1,1.075,1.075,0,0,0-1-1H12C11,11.3,10,11.3,10,10.3Z",
    transform: "translate(17.302 -0.698) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 11,
    height: 2,
    rx: 1,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0.103, 5.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M18.164.887a1,1,0,0,1,1,1v1.5a1,1,0,0,1-2,0v-.5h-1a1,1,0,0,1,0-2Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -0.098, 4.532)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWastepumpout);
export default __webpack_public_path__ + "static/media/wastepumpout.e8e21db7ef9a86bbde6e44f766c55e9d.svg";
export { ForwardRef as ReactComponent };